/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import WebGLContext from "App/web_gl_context";
import Pass from "App/render/webgl/passes/pass";

export default
class FullScreenQuad {

    private static _context: WebGLContext = null;

    public static create(aGlContext: WebGLContext) {

        this._context = aGlContext;

        let gl = this._context.getWebGLRenderingContext()

        let fullscreenVboID = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, fullscreenVboID);
        let vertices = new Float32Array([-1.0, -1.0, 0.0, 1.0, -1.0, 0.0, 1.0, 1.0, 0.0, -1.0, -1.0, 0.0, 1.0, 1.0, 0.0, -1.0, 1.0, 0.0]);

        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);

        return fullscreenVboID;
    }

    public static render(aVboID: WebGLBuffer, aRenderPass: Pass) {
        // TODO: use the appropriate vertex buffer according to the rendered view
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = this._context.getWebGLRenderingContext();

        // because during rendering the front face could be defined as CW
        gl.frontFace(gl.CCW);
        gl.disable(gl.CULL_FACE);

        // read the current state
        gl.disable(gl.DEPTH_TEST);

        gl.enableVertexAttribArray(shader.attributeLocations.a_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, aVboID);

        gl.vertexAttribPointer(shader.attributeLocations.a_position, 3, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLES, 0, 6);

        gl.disableVertexAttribArray(shader.attributeLocations.a_position);

        // todo: restore previous state
        gl.enable(gl.DEPTH_TEST);
    }
}
